import UserAccessDto from '@/features/auth/login/types/UserAccessDto';
import { MyAccessDto } from '../types/MyAccessDto';

export const CURRENT_COMPANY_STORAGE_KEY = 'campdesk.current-company-id';

// localStorage bywa niedostępny (prywatne okno, zablokowane dane, testy w node) — każde użycie w try/catch.
const readFromStorage = (): string | null => {
  try {
    return localStorage.getItem(CURRENT_COMPANY_STORAGE_KEY);
  } catch {
    return null;
  }
};

// Storage czytamy tylko przy starcie karty: wybór firmy w innej karcie nie może po cichu
// zmienić X-Tenant-Id tej karty, a zablokowany storage nie może zgubić wyboru w trakcie sesji.
let currentCompanyId: string | null = readFromStorage();

export const readStoredCompanyId = (): string | null => currentCompanyId;

export const storeCompanyId = (companyId: string): void => {
  currentCompanyId = companyId;
  try {
    localStorage.setItem(CURRENT_COMPANY_STORAGE_KEY, companyId);
  } catch {
    // bez storage wybór żyje tylko do przeładowania karty
  }
};

export const clearStoredCompanyId = (): void => {
  currentCompanyId = null;
  try {
    localStorage.removeItem(CURRENT_COMPANY_STORAGE_KEY);
  } catch {
    // jak wyżej
  }
};

export const selectCurrentAccess = (
  me: MyAccessDto | undefined,
  storedCompanyId: string | null,
): UserAccessDto | undefined => {
  const accesses = me?.accesses ?? [];
  if (accesses.length === 0) return undefined;
  return accesses.find((a) => a.companyId === storedCompanyId) ?? accesses[0];
};

export const resolveCurrentCompanyId = (
  me: MyAccessDto | undefined,
): string | null =>
  selectCurrentAccess(me, readStoredCompanyId())?.companyId ?? null;
